<template>
    <Head :title="'St. Johns County Homes for Sale'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/current-listings" />
        <meta name="description" content="Explore St. Johns County homes for sale, including Julington Creek properties. Browse Gina Betbeze’s listings and find your ideal home with ease." />
    </Head>
    <!-- Simple Blurb -->

    <PageContent
        :id="'about-page'"
        :breadcrumbs="['Home', 'Current Listings']"
        :header="'Current Listings'"
    >
        <BasicContainer>

            <ParaHovaCards
                v-for="listing in listings.data"
                :key="listing.title"
                :data-image="listing.image"
                :title="listing.title"
                :price="listing.price"
                :beds="listing.beds"
                :baths="listing.baths"
                :sqft="listing.sqft"
                :cityState="listing.cityState"
                :zip="listing.zip"
                :description="listing.description"
                :sold="listing.sold"
                :status="listing.status"
                :remaxLink="listing.remaxLink"
                :was_seller_agent="listing.was_seller_agent"
            ></ParaHovaCards>

            <Pagination :items="listings"/>
        </BasicContainer>
    </PageContent>
</template>
<script setup>
import PageContent from "../Components/Layout/PageContent.vue";
import HomeLayout from "../Layouts/HomeLayout.vue";
import ParaHovaCards from "../Components/PageContent/ParaHovaCards.vue";
import Breadcrumbs from "../Components/PageContent/Breadcrumbs.vue";
import BasicContainer from "../Components/PageContent/Containers/BasicContainer.vue";
import MainHead from "../Components/PageContent/MainHead.vue";
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/vue/24/solid";
import Pagination from '@/Components/PageContent/Pagination.vue';
import { onMounted, ref } from "vue";
import { Head, Link, usePage } from "@inertiajs/vue3";

defineOptions({ layout: HomeLayout });
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    listings: {
        type: Object,
        required: true
    }
});
const page = usePage();

// Old manual object.
// const cards = ref([
//     {
//         image: "/images/theme/listings/worcester-ct-567.jpeg",
//         title: "567 WORCESTER CT ",
//         price: "$349,900",
//         beds: "3",
//         baths: "3",
//         sqft: "2,162",
//         cityState: "Jacksonville, FL",
//         zip: "32218",
//         description:
//             "Welcome home to THIS ECO FRIENDLY HOME WITH SOLAR PANELS Discover your dream home with this spacious 3-BR, 2.5-BA residence located just minutes from I-95 in North Jacksonville; just a short drive to the city attractions and NS Mayport, making this the ideal spot for both work and leisure. SOLAR PANEL SYSTEM offers low utility bills. NO CDD and low HOA fees make this home even more affordable....",
//         sold: false,
//         remaxLink:
//             "https://www.remax.com/fl/jacksonville/home-details/567-worcester-ct-jacksonville-fl-32218/15618651549787397604/M00000141/2030715",
//     },
// ]);
</script>

<style scoped></style>
